module.exports = __webpack_public_path__ + "images/emoji/cherries.9ee7eb5507ff1b2af7ca.png";